import { createGlobalStyle } from "styled-components";

export const darkTheme = {
  body: "rgb(23 33 45)",
  textColor: "lightblue",
  iconText: "slateblue",
  logoWave: "slateblue",
  cardBorder: "orange",
};

export const lightTheme = {
  body: "#FFF",
  textColor: "#635B6C",
  iconText: "#8C8C9C",
  logoWave: "lightblue",
  cardBorder: "lightblue",
};

export const GlobalStyles = createGlobalStyle`
    html {
      scroll-behavior: smooth;
    }    
    body {
        background: ${(props) => props.theme.body};
        color: ${(props) => props.theme.textColor};
        transition: .3s ease;
        margin: 0;
        font-family: lato;
        overflow-x: hidden;
        background-size: cover;
        background-attachment: fixed;
    }
    /* Card */
    .card {
        background-color: ${(props) => props.theme.body};
        border-radius: 1rem;
        border: ${(props) => props.theme.logoWave} 0.1rem solid;
        transition: all 0.4s ease-in;
        box-shadow: 0.4rem 0.4rem 0.6rem #00000040;
        min-height: 13em;
    }
   
   .card:hover {
        /* transform: translateY(-0.25rem); */
        border: ${(props) => props.theme.cardBorder} 0.1em solid;
        border-radius: 0 2.5rem 0 2.5rem;
    }

    

    /* BUTTON */
    /* From uiverse.io by @adamgiebl */
    button {
        padding: 8px 30px;
        text-align: center;
        font-size: 18px;
        letter-spacing: 1px;
        text-decoration: none;
        color: slateblue;
        background: transparent;
        cursor: pointer;
        transition: ease-out 0.5s;
        border: 1px solid slateblue;
        border-radius: 10px;
        box-shadow: inset 0 0 0 0 slateblue;
        position: absolute;
        right: 10px;
        bottom: 10px;
    }

    .button_icon {
        transition: ease-out 0.5s;
    }

    button:hover {
        color: white;
        box-shadow: inset 0 -100px 0 0 slateblue;
        border-radius: 0 1rem 0 1rem;
        .button_icon{
            color: white;
        }
    }

    button:active {
        transform: scale(0.9);
    }

    button:disabled {
        pointer-events: none;
    }

    button:disabled,
    button:focus:disabled,
    button:hover:disabled,
    button:active:disabled {
        opacity: 40%;
        color: ${(props) => props.theme.textColor};
        cursor: not-allowed;
    }

   /* END BUTTON */
    .icon {
        color: ${(props) => props.theme.iconText};
    }
    /* SOCIAL MEDIA ICONS */
    .icon:hover {
        color: ${(props) => props.theme.textColor};
    }

    .button_icon {
        color: slateblue;
    }

    .myfont {
        font-weight: 600;
        color: slateblue;
        font-family: 'Roboto', sans-serif;
    }

    .myfont_p {
      letter-spacing: 1px;
      font-size: 18px;
    }
    /* HEADSHOT IN THE FOOTER */
    .headshot {
        vertical-align: middle;
        width: 50px;
        height: 50px;
        border: 1px solid lightblue;
        border-radius: 50%;
    }

    /* WHEN LOGO IMAGE IS ACTIVE */
    /* .logo{
        height:50px;
        width: auto;
    } */

    a {
        text-decoration: none;
    }

    .footer {
        left: 0;
        bottom: 0;
        width: 100%;
        text-align: center;
    }

    .header {
        background: ${(props) => props.theme.body}
    }

    /* LOGO START */
    .loader span:nth-child(1) {
        color: ${(props) => props.theme.textColor};;
        -webkit-text-stroke: 0.3px ${(props) => props.theme.textColor};;
    }
    .loader span:nth-child(2) {
        color: ${(props) => props.theme.logoWave};;
        -webkit-text-stroke: 1px ${(props) => props.theme.logoWave};;
        animation: uiverse723 3s ease-in-out infinite;
    }

    /* BACKGROUND START */
    .circles {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* change to 200% or depending how much content */
        height: 640%; 
        overflow: hidden;
        pointer-events: none 
    }
    .circles li{
        position: absolute;
        display: block;
        list-style: none;
        width: 20px;
        height: 20px;
        background: ${(props) => props.theme.logoWave};
        animation: animate 25s linear infinite;
        bottom: -150px;
        
    }

    .circles li:nth-child(1){
        left: 65%;
        width: 80px;
        height: 80px;
        animation-delay: 0s;
    }


    .circles li:nth-child(2){
        left: 62.5%;
        width: 20px;
        height: 20px;
        animation-delay: 2s;
        animation-duration: 22s;
    }

    .circles li:nth-child(3){
        left: 65%;
        width: 20px;
        height: 20px;
        animation-delay: 2s;
        animation-duration: 35s;
    }

    .circles li:nth-child(4){
        left: 67.5%;
        width: 60px;
        height: 60px;
        animation-delay: 0s;
        animation-duration: 28s;
    }

    .circles li:nth-child(5){
        left: 70%;
        width: 20px;
        height: 20px;
        animation-delay: 0s;
    }

    .circles li:nth-child(6){
        left: 75%;
        width: 110px;
        height: 110px;
        animation-delay: 6s;
    }

    .circles li:nth-child(7){
        left: 80%;
        width: 150px;
        height: 150px;
        animation-delay: 17s;
        animation-duration: 45s;
    }

    .circles li:nth-child(8){
        left: 77.5%;
        width: 25px;
        height: 25px;
        animation-delay: 15s;
        animation-duration: 55s;
    }

    .circles li:nth-child(9){
        left: 87.5%;
        width: 15px;
        height: 15px;
        animation-delay: 0s;
        animation-duration: 35s;
    }

    .circles li:nth-child(10){
        left: 85%;
        width: 150px;
        height: 150px;
        animation-delay: 0s;
        animation-duration: 50s;
    }

    @keyframes animate {

        0%{
            transform: translateY(0) rotate(0deg);
            opacity: 1;
            border-radius: 0;
        }

        100%{
            /* change -1000px to -2000 depending on how much content */
            transform: translateY(-5000px) rotate(720deg);
            opacity: 0;
            border-radius: 50%;
        }

    }
     /* BACKGROUND ENDS */

    /* Breakpoint: sm and down */
    @media only screen and (max-width: 576px) {
        .card {
            min-height: 14em;
        }
    }

    /* Breakpoint: sm and up */
    @media only screen and (min-width: 576px) {
        .circles {
            height: 350%;
        }

    }
    /* Breakpoint: md and up */
    @media only screen and (min-width: 768px) {

    }

    /* Breakpoint: lg and up */
    @media only screen and (min-width: 992px) {
        .card {
            min-height: 14em;
        }
    }
    /*  */

`;
